export const createGiftUrl = ({ urlTemplate }, name) =>
  `${urlTemplate.replace('%s', name)}`
